module.exports = __webpack_public_path__ + "img/step3.01e891ff.png";